import { URI } from 'monaco-editor/esm/vs/base/common/uri.js';
import { Range } from 'monaco-editor/esm/vs/editor/common/core/range.js';
import { createDecorator } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
function isIDocumentContext(obj) {
    return (!!obj &&
        typeof obj === 'object' &&
        'uri' in obj && obj.uri instanceof URI &&
        'version' in obj && typeof obj.version === 'number' &&
        'ranges' in obj && Array.isArray(obj.ranges) && obj.ranges.every(Range.isIRange));
}
function isIUsedContext(obj) {
    return (!!obj &&
        typeof obj === 'object' &&
        'documents' in obj &&
        Array.isArray(obj.documents) &&
        obj.documents.every(isIDocumentContext));
}
var InteractiveSessionVoteDirection;
( (function(InteractiveSessionVoteDirection) {
    InteractiveSessionVoteDirection[InteractiveSessionVoteDirection["Down"] = 0] = "Down";
    InteractiveSessionVoteDirection[InteractiveSessionVoteDirection["Up"] = 1] = "Up";
})(InteractiveSessionVoteDirection || (InteractiveSessionVoteDirection = {})));
var InteractiveSessionCopyKind;
( (function(InteractiveSessionCopyKind) {
    InteractiveSessionCopyKind[InteractiveSessionCopyKind["Action"] = 1] = "Action";
    InteractiveSessionCopyKind[InteractiveSessionCopyKind["Toolbar"] = 2] = "Toolbar";
})(InteractiveSessionCopyKind || (InteractiveSessionCopyKind = {})));
const IChatService = ( createDecorator('IChatService'));
export { IChatService, InteractiveSessionCopyKind, InteractiveSessionVoteDirection, isIDocumentContext, isIUsedContext };
